export enum WithdrawalWalletType {
  SOLANA = 'SOLANA',
  ALGORAND = 'ALGORAND',
  EVM = 'EVM',
}



